import React from "react";
import PropTypes from "prop-types";
import { Card, Grid, Box } from "@mui/material";
import {
  LocalParking,
  AccessTime,
  CheckCircle,
  People,
  Warning as WarningIcon,
  Add,
} from "@mui/icons-material";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import MDButton from "shared/components/MDButton";

const HeaderPropiedades = ({
  onRefresh,
  loading = false,
  usuariosStats = null,
  onAddClick = null,
}) => {
  const formatTime = () => {
    const now = new Date();
    return now.toLocaleTimeString("es-ES", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  return (
    <Card sx={{ backgroundColor: "#0d47a1", borderRadius: "12px", p: 2 }}>
      <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
        <Grid item xs={12} md={6}>
          <MDBox display="flex" alignItems="center" gap={2}>
            <LocalParking sx={{ color: "#4cc9f0", fontSize: 32 }} />
            <Box>
              <MDTypography variant="h5" color="white" fontWeight="bold">
                Administración de Propiedades
              </MDTypography>
              <MDTypography variant="caption" color="white" display="block">
                Gestión de Propiedades Gopass
              </MDTypography>
            </Box>
          </MDBox>
        </Grid>

        <Grid item xs={12} md={6}>
          <MDBox display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
            <MDTypography variant="caption" color="white">
              <AccessTime fontSize="inherit" sx={{ mr: 0.5 }} />
              {formatTime()}
            </MDTypography>

            {/* Botón Nueva Propiedad */}
            <MDButton
              variant="contained"
              color="white"
              size="small"
              onClick={onAddClick}
              disabled={loading}
              startIcon={<Add />}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
                color: "#0d47a1",
                "&:hover": { backgroundColor: "#e3f2fd" },
                "&.Mui-disabled": {
                  backgroundColor: "rgba(255,255,255,0.3)",
                  color: "rgba(255,255,255,0.5)",
                },
              }}
            >
              Nueva Propiedad
            </MDButton>

            {/* Botón Actualizar */}
            <MDButton
              variant="contained"
              color="white"
              size="small"
              onClick={onRefresh}
              disabled={loading}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
                color: "#0d47a1",
                "&:hover": { backgroundColor: "#e3f2fd" },
                "&.Mui-disabled": {
                  backgroundColor: "rgba(255,255,255,0.3)",
                  color: "rgba(255,255,255,0.5)",
                },
              }}
            >
              {loading ? "Cargando..." : "Actualizar"}
            </MDButton>
          </MDBox>
        </Grid>
      </Grid>

      {/* Estadísticas de Usuarios - Opcional */}
      {usuariosStats && (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12} sm={6} md={3}>
            <MDBox
              sx={{
                backgroundColor: "rgba(255,255,255,0.1)",
                borderRadius: "8px",
                p: 1.5,
                textAlign: "center",
              }}
            >
              <MDTypography variant="h4" color="white" fontWeight="bold">
                {usuariosStats.total || 0}
              </MDTypography>
              <MDTypography variant="caption" color="white">
                Total Propiedades
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <MDBox
              sx={{
                backgroundColor: "rgba(255,255,255,0.1)",
                borderRadius: "8px",
                p: 1.5,
                textAlign: "center",
              }}
            >
              <MDTypography variant="h4" color="white" fontWeight="bold">
                {usuariosStats.activos || 0}
              </MDTypography>
              <MDTypography variant="caption" color="white">
                Propiedades Activas
              </MDTypography>
            </MDBox>
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

HeaderPropiedades.propTypes = {
  onRefresh: PropTypes.func,
  loading: PropTypes.bool,
  usuariosStats: PropTypes.object,
  onAddClick: PropTypes.func,
};

HeaderPropiedades.defaultProps = {
  onRefresh: null,
  loading: false,
  usuariosStats: null,
  onAddClick: null,
};

export default HeaderPropiedades;
